import {Platform} from 'react-native';

// Material Symbols font family - different naming on web vs native
// Web: uses CSS font-face name 'Material Symbols Outlined'
// Native: uses filename without extension 'MaterialSymbolsOutlined'
export const MATERIAL_ICONS_FONT = Platform.OS === 'web'
  ? 'Material Symbols Outlined'
  : 'MaterialSymbolsOutlined';
